export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const sessionIdToName = {
  1: 'Admin',
  2: 'Admin-Assign Roles',
  3: 'Admin-Update Permissions',
  4: 'Attendance List',
  5: 'Company Docs',
  6: 'Dashboard',
  7: 'Employees',
  8: 'Leave History',
  9: 'Leave Management',
  10: 'Occasions',
  11: 'Mark Attendance',
  12: 'Monthly View',
  13: 'Online Users',
  // 14: 'Payslip Generate',
  15: 'Payslip',
  16: 'Regularize Attendance',
  17: 'Slack Status',
  18: 'Status',
  19: 'View Attendance',
};

export const AUTH_URL = process.env.REACT_APP_PROD_AUTH_URL;

export const secretkey = process.env.REACT_APP_SECRET_KEY;

export const attendaceListTableColumns = [
  {
    PageLayout: 'Name Data',
    accessor: 'Name Data',
  },
  {
    PageLayout: 'Type',
    accessor: 'Type',
  },
  {
    PageLayout: 'Working Hour',
    accessor: 'Working Hour',
  },
  {
    PageLayout: 'Sessions',
    accessor: 'Log In/Out Count',
  },
  {
    PageLayout: 'ScreenShots',
    accessor: 'ScreenShots',
  },
  {
    PageLayout: 'Actions',
    accessor: 'Actions',
  },
];

export const attendaceDetailTableColumns = [
  {
    PageLayout: 'Sn',
    accessor: 'sn',
  },
  {
    PageLayout: 'Date',
    accessor: 'date',
  },
  {
    PageLayout: 'Employee Active Hours',
    accessor: 'workingGrant',
  },
  {
    PageLayout: 'Screen Shots',
    accessor: 'screenshots',
  },
  {
    PageLayout: 'Working Hours',
    accessor: 'totalTime',
  },
];
export const attendanceDetailsTable = [
  {
    PageLayout: 'HRMS Agent Login',
    accessor: 'hrmsAgentLogin',
  },
  {
    PageLayout: 'HRMS Agent Logout',
    accessor: 'hrmsAgentLogout',
  },
];

export const employeeCardTable = [
  {
    PageLayout: 'User',
    accessor: 'user',
  },
  {
    PageLayout: 'Name',
    accessor: 'name',
  },
  {
    PageLayout: 'Employee Status',
    accessor: 'empStatus',
  },
  {
    PageLayout: 'Phone Number',
    accessor: 'phoneNumber',
  },
  {
    PageLayout: 'Email',
    accessor: 'email',
  },
  {
    PageLayout: 'Action',
    accessor: 'action',
  },
];

export const monthlyAttendanceColums = [
  { PageLayout: 'Name', accessor: 'name' },
  { PageLayout: 'Total Days', accessor: 'totalDays' },
  { PageLayout: 'Agent Hours', accessor: 'agentHours' },
  {
    PageLayout: 'Expected Hours',
    accessor: 'expectedWorking',
  },
  {
    PageLayout: 'Deficit',
    accessor: 'deficit',
  },
  { PageLayout: 'Paid Leaves', accessor: 'paidLeaveCount' },
  { PageLayout: 'Unpaid Leaves', accessor: 'unPaidLeaveCount' },

  { PageLayout: 'View', accessor: 'action' },
];

export const CONSENT_VERSION = '1.0';
